import React from 'react';
import PropTypes from 'prop-types';
import './text.scss';

const AppText = ({
   children,
   variant = 'body1', // h1, h2, h3, subtitle1, subtitle2, body1, body2, caption
   color = 'primary', // primary, secondary, tertiary, muted, inverse, success, warning, danger
   weight = 'regular', // regular, medium, semibold, bold
   className = '',
   as,
   ...props
}) => {
   const getDefaultElement = variant => {
      switch (variant) {
         case 'h1':
            return 'h1';
         case 'h2':
            return 'h2';
         case 'h3':
            return 'h3';
         case 'subtitle1':
         case 'subtitle2':
            return 'h6';
         case 'body1':
         case 'body2':
            return 'p';
         case 'caption':
            return 'span';
         default:
            return 'span';
      }
   };

   const Component = as || getDefaultElement(variant);

   return (
      <Component
         className={`ct-text ct-text--${variant} ct-text--${color} ct-text--weight-${weight} ${className}`}
         {...props}
      >
         {children}
      </Component>
   );
};

AppText.propTypes = {
   children: PropTypes.node,
   variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption']),
   color: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'muted', 'inverse', 'success', 'warning', 'danger']),
   weight: PropTypes.oneOf(['regular', 'medium', 'semibold', 'bold']),
   className: PropTypes.string,
   as: PropTypes.elementType
};

export default AppText;
